// removed by extract-text-webpack-plugin
module.exports = {"Canvas":"FestivalQualityChart__Canvas__11KOJ","Score":"FestivalQualityChart__Score__mCh_Z"};